export default __webpack_public_path__ + "static/media/enrolled.c1b2df76.png";